import {
  Button,
  Card,
  CardActions,
  LinearProgress,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Detail from "../../components/task-creator/Detail";
import { getTask } from "../../services/task.service";
import { Task } from "../../types/task";

export default function TaskInfo() {
  const navigate = useNavigate();
  const params = useParams();

  const [task, setTask] = useState<Task | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchTask = async () => {
    if (params?.id) {
      setIsLoading(true);
      try {
        const response = await getTask(params.id);
        setTask(response);
      } catch (error) {
        console.error("🚀 ~ fetchTask ~ error", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchTask();
  }, []);

  return (
    <>
      <Typography variant="subtitle1" className="font-bold mb-4">
        Task Info
      </Typography>
      <Card className="p-4">
        {isLoading ? <LinearProgress /> : <Detail task={task!} />}
        <CardActions className="flex justify-center md:justify-end pb-0">
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </CardActions>
      </Card>
    </>
  );
}
